import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import qs from 'qs';
import { filterOutRequestExtraParameters, handleApiRequestSuccessData, handleRequestError } from '../../utils/request';
import { api } from '../index';
export var apiQueryWhetherTheEmailHaveQuote = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/switch_to_jove/website/assumption-quote-id?".concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 3:
            res = _context.sent;
            handleApiRequestSuccessData(res);
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function apiQueryWhetherTheEmailHaveQuote(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiUpdateQuoteCallBackDate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.patch("/admin/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/call-back-date"), payload);

          case 3:
            res = _context2.sent;
            handleApiRequestSuccessData(res);
            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiUpdateQuoteCallBackDate(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiDeleteQuote = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.post("/admin/quotes_plus/bulk-delete", payload.ids);

          case 3:
            res = _context3.sent;
            handleApiRequestSuccessData(res);
            return _context3.abrupt("return", [res.data]);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function apiDeleteQuote(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var getEstimatedTotalPriceWithPremium = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload, config) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.get("/quotes_plus/estimate-override-premium/".concat(payload.quoteId, "?").concat(qs.stringify(payload)));

          case 3:
            res = _context4.sent;
            handleApiRequestSuccessData(res);
            return _context4.abrupt("return", [res.data]);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));

  return function getEstimatedTotalPriceWithPremium(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiCreateQuoteByUploadApplicationFormFile = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload, config) {
    var queryParams, res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            queryParams = {
              promotion_id: payload === null || payload === void 0 ? void 0 : payload.productId
            };
            _context5.next = 4;
            return api.post("/quotes/upload-proposal-form?".concat(qs.stringify(queryParams)), payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 4:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data]);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));

  return function apiCreateQuoteByUploadApplicationFormFile(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiUpdateQuoteBillingSchedulePaymentStatus = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.patch("/quote_billing_schedules/".concat(payload === null || payload === void 0 ? void 0 : payload.billingScheduleId, "/payment-status"), payload);

          case 3:
            res = _context6.sent;
            handleApiRequestSuccessData(res);
            return _context6.abrupt("return", [res.data]);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));

  return function apiUpdateQuoteBillingSchedulePaymentStatus(_x8) {
    return _ref6.apply(this, arguments);
  };
}();
export var getEstimatedTotalPriceWithCoverage = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload, config) {
    var newPayload, res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            newPayload = filterOutRequestExtraParameters(payload);
            delete newPayload.quoteId;
            _context7.next = 5;
            return api.post("/quotes_plus/estimate-override-premium-difference/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId), newPayload, config);

          case 5:
            res = _context7.sent;
            handleApiRequestSuccessData(res);
            return _context7.abrupt("return", [res.data]);

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0, payload));

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 10]]);
  }));

  return function getEstimatedTotalPriceWithCoverage(_x9, _x10) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiApproveBusinessActivityDescription = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api.post("/admin/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/approve-activity-description"), payload);

          case 3:
            res = _context8.sent;
            handleApiRequestSuccessData(res);
            return _context8.abrupt("return", [res.data]);

          case 8:
            _context8.prev = 8;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", handleRequestError(_context8.t0, payload));

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 8]]);
  }));

  return function apiApproveBusinessActivityDescription(_x11) {
    return _ref8.apply(this, arguments);
  };
}();